import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Contact from './components/Contact';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-8 py-6 flex items-center justify-between">
          <div className="text-2xl font-bold tracking-tight">ELVIS DOO SABAC</div>
          <div className="flex items-center gap-12">
            <button
              onClick={() => scrollToSection('home')}
              className="text-sm font-light tracking-[3px] hover:opacity-60 transition-opacity cursor-pointer whitespace-nowrap"
            >
              HOME
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-sm font-light tracking-[3px] hover:opacity-60 transition-opacity cursor-pointer whitespace-nowrap"
            >
              ABOUT
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="text-sm font-light tracking-[3px] hover:opacity-60 transition-opacity cursor-pointer whitespace-nowrap"
            >
              PRODUCTS
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-sm font-light tracking-[3px] hover:opacity-60 transition-opacity cursor-pointer whitespace-nowrap"
            >
              CONTACT
            </button>
          </div>
        </div>
      </nav>

      {/* Sections */}
      <section id="home">
        <Hero />
      </section>
      <section id="about">
        <About />
      </section>
      <section id="products">
        <Products />
      </section>
      <section id="contact">
        <Contact />
      </section>
    </div>
  );
}
